import LocalStorage, { StorageKeys } from 'utils/local-storage';

const localeSpecificStorageKeys = [StorageKeys.LANGUAGE, StorageKeys.REGION];

export const clearLocaleStorage = () => {
  const nonRegionSpecificStorageKeys = Object.values(StorageKeys).filter(
    key => !localeSpecificStorageKeys.includes(key as StorageKeys)
  ) as StorageKeys[];
  // Wipe out region specific keys
  LocalStorage.clear({ excludeKeys: nonRegionSpecificStorageKeys });
};
